<template>
  <div>
    <!-- Header -->
    <div class="pageHeader page-header__flex">
      Device Jobs<br>
    </div>

    <!-- Body -->
    <div class="jobs-body">
      <div class="jobs-body__inner">
        <div class="jobs-body__inspector-crumbs">
          <span @click="doAction()" class="jobs-body__inspector-crumb-item"> Home /</span> 
          <span v-if="action === 'viewJob'" class="jobs-body__inspector-crumb-item"> {{ viewJob }} /</span>
          <span v-if="action === 'createJob'" class="jobs-body__inspector-crumb-item"> Create /</span> 
        </div>

        <div class="jobs-body__tab-container" style="position: relative; margin-bottom: 1em; margin-left: .25em;">
          <div class="dropdown">
            <select :disabled="['scheduleJob', 'rerunDeployment'].includes(this.action)" v-on:change="() => { tenant === 'null' ? tenant = null : null; changeTenant() }" v-model="tenant" class="form-select form-select-sm" style="margin-right: .75em;" aria-label="Select tenant">
              <option value="null" disabled selected>Select tenant</option>
              <option v-for="{value, text} in tenants" :value="value" :key="text">{{ text }}</option>
            </select>
          </div>
          <div style="flex: 1"></div>
          <button 
            v-if="jobsManager && !action" 
            @click="doAction('importItem')" 
            style="margin-right: .75em;" 
            class="btn-sm btn-primary btn-margin jobs-body__tab-item--button" 
            aria-label="Import Template"
          >
            Import
          </button> 
          <button aria-label="Create Template" v-if="jobsManager && [null, 'viewJobs', 'releasesAndTemplates'].includes(action)" @click="doAction('createJob')" style="margin-right: .75em;" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
            Create
          </button>
          <button aria-label="Go Back" v-if="action" @click="doAction()" style="margin-right: .75em; color: #484848; border-color: transparent; background-color: transparent;" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button jobs-body__tab-item--back">
            Go Back
          </button>
          <button v-b-tooltip.hover title="Refresh" aria-label="Refresh View" v-if="[null, 'viewJobs'].includes(action)" @click="getItems()" style="border-color: transparent; background-color: transparent;">
            <img alt="Refresh Button" src="../../assets/images/refresh.svg" class="jobs-body__tab-item--refresh-button" />
          </button>
        </div>

        <ul class="nav">
          <li class="nav-item" @click="doAction()" :class="{ active: !action }">
            <a class="nav-link" aria-current="page" href="javascript:void(0);">Overview</a>
          </li>
          <li class="nav-item" @click="doAction('releasesAndTemplates')" :class="{ active: action === 'releasesAndTemplates' }">
            <a class="nav-link" aria-current="page" href="javascript:void(0);">Releases and Templates</a>
          </li>
          <li class="nav-item" @click="doAction('archived')" :class="{ active: action === 'archived' }">
            <a class="nav-link" aria-current="page" href="javascript:void(0);">Archived</a>
          </li>
          <li v-if="tenant" class="nav-item" @click="doAction('viewJobs')" :class="{ active: action === 'viewJobs' }">
            <a class="nav-link" href="javascript:void(0);">Tenant Portal <small>({{ tenant }})</small></a>
          </li>
        </ul>

        <!-- DYNAMIC VIEWPORTS -->
        <!-- // Dashboard -->
        <div class="jobs-body-inspector-row">
          <div v-if="['archived', 'releasesAndTemplates'].includes(action)" class="jobs-body-inspector">   
            <div v-if="rerender" class="jobs-body-inspector__details">
              <p>
                <strong style="display: flex; justify-content: space-between; align-items: center;"> 
                  <span v-b-toggle="`collapse-releases`" :ref="'showReleases'" style="color: #484848; text-decoration: none;" @click="releasesHidden = !releasesHidden">
                    Releases
                    <a href="javascript:void(0)" v-if="releasesHidden">
                      <small>Show</small>
                    </a>
                    <a href="javascript:void(0)" v-if="!releasesHidden">
                      <small>Hide</small>
                    </a>
                  </span> 
                  <b-input-group style="width: 300px;">
                    <template #append>
                      <b-input-group-text><strong>🔍</strong></b-input-group-text>
                    </template>
                    <b-form-input v-model="searchReleasesPhrase" @input="getReleases({ archived: action === 'archived' })" placeholder="Search releases"></b-form-input>
                  </b-input-group>
                </strong>
              </p>
              <div v-if="loading" style="flex: 1; margin-top: 5em; margin-bottom: 5em; display: flex; justify-content: center; align-items: center">
                <img src="../../assets/images/loader-a2.gif" alt="Loading items" width="50px" />
              </div>
              
              <b-collapse visible id="collapse-releases">
                <div v-if="(!loading && (isApproved || jobsManager))" class="jobs-body-inspector__job-item jobs-body__bounce" v-for="{_id, label, notes, job, prerequisites, createdOn, createdBy, isApproved, approvedBy, approvedOn, isInService} in releases.data" :value="_id" :key="_id">
                  <div v-if="isApproved || jobsManager" style="display: flex; gap: .75em; justify-content: space-between; align-items: center;">
                    <b-button :id="`jobDetails-${_id}`" style="width: 24px; height: 24px; border-width: 0px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--radio-button">
                      <font-awesome-icon :style="{ width: '15px', height: '15px' }" icon="info" /> 
                    </b-button>
                    <span style="font-weight: 400;">
                      <b>
                        {{label}}                     
                      </b> 
                    </span>

                    <b-popover :target="`jobDetails-${_id}`" id="jobDetails" 
                      triggers="hover" placement="top"
                      v-bind:title="'Release Details'">
                      <p>
                        <strong>Approval Information: </strong>
                        {{ 
                          isApproved ? 
                          `Approved by ${approvedBy} on ${moment(approvedOn).format("dddd, MMMM Do YYYY, h:mm:ss a")}.` : 
                          `${isInService ? 'Approval Pending' : 'Out of Service'}` 
                        }}
                      </p>
                      <p>
                        <strong>Creation: </strong> 
                        <span style="font-weight: 300;">
                          {{`Created by ${createdBy} on ${moment(createdOn).format("dddd, MMMM Do YYYY, h:mm:ss a")}`}}
                        </span>
                      </p>
                    </b-popover>

                    <div style="flex: 1; display: flex; gap: .75em; justify-content: flex-end;">
                      <button v-if="!isApproved && isInService && jobsManager" style="padding: 5px; max-height: 30px;" @click="doAction('removeServiceTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Archive
                      </button>
                      <button v-if="jobsManager" style="padding: 5px; max-height: 30px;" @click="doAction('editTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        {{ action === 'archived' && !isInService ? 'Return to Service' : 'Edit'}}
                      </button>
                      <button v-if="!isApproved && isInService && jobsManager && action !== 'archived'" style="padding: 5px; max-width: 190px; max-height: 30px;" @click="doAction('approveTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Approve
                      </button>
                      <button v-if="isApproved && jobsManager" style="padding: 5px; max-width: 150px; max-height: 30px;" @click="doAction('unapproveTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Unapprove
                      </button>
                      <button 
                        v-if="isApproved && jobsManager"
                        @click="doAction('exportItem', _id)" 
                        style="padding: 5px; max-width: 150px; max-height: 30px;" 
                        class="btn-sm btn-primary btn-margin jobs-body__tab-item--button" 
                        aria-label="Export Template"
                      >
                        Export 
                      </button> 
                    </div>
                    <div style="display: flex; justify-content: flex-end;">
                      <button style="" v-if="(isApproved || jobsManager) && isInService" @click="doAction('scheduleJob', _id)" class="btn-sm btn-success btn-margin jobs-body__tab-item--schedule-button">
                        <font-awesome-icon :style="{ width: '14px' }" icon="cloud-upload-alt" /> 
                      </button>
                    </div>
                  </div>
                  <p v-if="isApproved || jobsManager" style="margin: 0 10px;">
                    <span style="font-weight: 300;" v-html="notes" />
                  </p>
                  <p v-if="isApproved || jobsManager">
                    <strong>
                      <a v-b-toggle="`collapse-tasks-${_id}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                        <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 12px;">
                          <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                          <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                          Tasks <small>({{ job.length }})</small>
                        </div>
                      </a>
                    </strong>
                  </p>
                  <b-collapse v-if="(isApproved || jobsManager)" :id="`collapse-tasks-${_id}`">
                    <b-card>
                      <div class="jobs-body-inspector__job-item" v-for="(item, index) in job" :value="index" :key="index">
                        <p>
                          <strong >Type:</strong> <span style="font-weight: 300;">{{item.type}}</span>
                        </p>
                        <p v-if="item.payload">
                          <strong >Payload:</strong> <span style="font-weight: 300;">{{item.payload}}</span>
                        </p>
                      </div>
                    </b-card>
                  </b-collapse>

                  <p v-if="prerequisites && (isApproved || jobsManager)">
                    <strong>
                      <a v-b-toggle="`collapse-prereqs-${_id}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                        <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 12px;">
                          <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                          <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                          Prerequisites <small>({{ prerequisites.length }})</small>
                        </div>
                      </a>
                    </strong>
                  </p>
                  <b-collapse v-if="isApproved || jobsManager" :id="`collapse-prereqs-${_id}`">
                    <b-card>
                      <div class="jobs-body-inspector__job-item" v-for="(item, index) in prerequisites" :value="index" :key="index">
                        <p>
                          <strong >Send:</strong> <span style="font-weight: 300;">{{item.key}} ({{item.releaseVersion}})</span>
                        </p>
                        <p>
                          <strong >Submodels:</strong> <span style="font-weight: 300;">{{item.subModels}}</span>
                        </p>
                      </div>
                    </b-card>
                  </b-collapse>
                </div>

              </b-collapse>
              
              <p style="margin-top: 15px;">
                <strong style="display: flex; justify-content: space-between; align-items: center;">
                  <span :ref="'showTemplates'" v-b-toggle="`collapse-templates`" style="color: #484848; text-decoration: none;" @click="templatesHidden = !templatesHidden">
                    Templates 
                    <a href="javascript:void(0)" v-if="templatesHidden">
                      <small>Show</small>
                    </a>
                    <a href="javascript:void(0)" v-if="!templatesHidden">
                      <small>Hide</small>
                    </a>
                  </span> 
                  <b-input-group style="width: 300px;">
                    <template #append>
                      <b-input-group-text><strong>🔍</strong></b-input-group-text>
                    </template>
                    <b-form-input v-model="searchTemplatesPhrase" @input="getTemplates()" placeholder="Search templates"></b-form-input>
                  </b-input-group>
                </strong>
              </p>
              <div v-if="loading" style="flex: 1; margin-top: 5em; margin-bottom: 5em; display: flex; justify-content: center; align-items: center">
                <img src="../../assets/images/loader-a2.gif" alt="Loading items" width="50px" />
              </div>

              <b-collapse visible id="collapse-templates">
                <div v-if="(!loading && (isApproved || jobsManager))" class="jobs-body-inspector__job-item jobs-body__bounce" v-for="{_id, label, notes, job, prerequisites, createdOn, createdBy, isApproved, approvedBy, approvedOn, isInService} in templates.data" :value="_id" :key="_id">
                  <div v-if="isApproved || jobsManager" style="display: flex; gap: .75em; justify-content: space-between; align-items: center;">
                    <b-button :id="`jobDetails-${_id}`" style="width: 24px; height: 24px; border-width: 0px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--radio-button">
                      <font-awesome-icon :style="{ width: '15px', height: '15px' }" icon="info" /> 
                    </b-button>
                    <span style="font-weight: 400;">
                      <b>
                        {{label}}                     
                      </b> 
                    </span>

                    <b-popover :target="`jobDetails-${_id}`" id="jobDetails" 
                      triggers="hover" placement="top"
                      v-bind:title="'Release Details'">
                      <p>
                        <strong>Approval Information: </strong>
                        {{ 
                          isApproved ? 
                          `Approved by ${approvedBy} on ${moment(approvedOn).format("dddd, MMMM Do YYYY, h:mm:ss a")}.` : 
                          `${isInService ? 'Approval Pending' : 'Out of Service'}` 
                        }}
                      </p>
                      <p>
                        <strong>Creation: </strong> 
                        <span style="font-weight: 300;">
                          {{`Created by ${createdBy} on ${moment(createdOn).format("dddd, MMMM Do YYYY, h:mm:ss a")}`}}
                        </span>
                      </p>
                    </b-popover>

                    <div style="flex: 1; display: flex; gap: .75em; justify-content: flex-end;">
                      <button v-if="!isApproved && isInService && jobsManager" style="padding: 5px; max-height: 30px;" @click="doAction('removeServiceTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Archive
                      </button>
                      <button v-if="jobsManager" style="padding: 5px; max-height: 30px;" @click="doAction('editTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        {{ action === 'archived' && !isInService ? 'Return to Service' : 'Edit'}}
                      </button>
                      <button v-if="!isApproved && isInService && jobsManager" style="padding: 5px; max-width: 190px; max-height: 30px;" @click="doAction('approveTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Approve
                      </button>
                      <button v-if="isApproved && jobsManager" style="padding: 5px; max-width: 150px; max-height: 30px;" @click="doAction('unapproveTemplate', _id)" class="btn-sm btn-primary btn-margin jobs-body__tab-item--button">
                        Unapprove
                      </button>
                      <button 
                        v-if="isApproved && jobsManager"
                        @click="doAction('exportItem', _id)" 
                        style="padding: 5px; max-width: 150px; max-height: 30px;" 
                        class="btn-sm btn-primary btn-margin jobs-body__tab-item--button" 
                        aria-label="Export Template"
                      >
                        Export 
                      </button> 
                    </div>
                    <div style="display: flex; justify-content: flex-end;">
                      <button style="" v-if="(isApproved || jobsManager) && isInService" @click="doAction('scheduleJob', _id)" class="btn-sm btn-success btn-margin jobs-body__tab-item--schedule-button">
                        <font-awesome-icon :style="{ width: '14px' }" icon="cloud-upload-alt" /> 
                      </button>
                    </div>
                  </div>
                  <p v-if="isApproved || jobsManager" style="margin: 0 10px;">
                    <span style="font-weight: 300;" v-html="notes" />
                  </p>
                  <p v-if="isApproved || jobsManager">
                    <strong>
                      <a v-b-toggle="`collapse-tasks-${_id}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                        <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 12px;">
                          <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                          <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                          Tasks <small>({{ job.length }})</small>
                        </div>
                      </a>
                    </strong>
                  </p>
                  <b-collapse v-if="(isApproved || jobsManager)" :id="`collapse-tasks-${_id}`">
                    <b-card>
                      <div class="jobs-body-inspector__job-item" v-for="(item, index) in job" :value="index" :key="index">
                        <p>
                          <strong >Type:</strong> <span style="font-weight: 300;">{{item.type}}</span>
                        </p>
                        <p v-if="item.payload">
                          <strong >Payload:</strong> <span style="font-weight: 300;">{{item.payload}}</span>
                        </p>
                      </div>
                    </b-card>
                  </b-collapse>

                  <p v-if="prerequisites && (isApproved || jobsManager)">
                    <strong>
                      <a v-b-toggle="`collapse-prereqs-${_id}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                        <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 12px;">
                          <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                          <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                          Prerequisites <small>({{ prerequisites.length }})</small>
                        </div>
                      </a>
                    </strong>
                  </p>
                  <b-collapse v-if="isApproved || jobsManager" :id="`collapse-prereqs-${_id}`">
                    <b-card>
                      <div class="jobs-body-inspector__job-item" v-for="(item, index) in prerequisites" :value="index" :key="index">
                        <p>
                          <strong >Send:</strong> <span style="font-weight: 300;">{{item.key}} ({{item.releaseVersion}})</span>
                        </p>
                        <p>
                          <strong >Submodels:</strong> <span style="font-weight: 300;">{{item.subModels}}</span>
                        </p>
                      </div>
                    </b-card>
                  </b-collapse>
                </div>
              </b-collapse>
            </div>
          </div>
          <div v-if="['viewJobs', null].includes(action)" class="jobs-body-inspector">
            <div v-if="rerender" class="jobs-body-inspector__details">
              <div class="jobs-body__tab-container">
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('*')" @change="adjustFilters('*'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    All
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('scheduled') || filters.includes('*')" 
                    @change="adjustFilters('scheduled'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    Scheduled
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('progressing') || filters.includes('*')" 
                    @change="adjustFilters('progressing'); searchJobs();">
                  <label style="color: #484848;">
                    Progressing
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('completed') || filters.includes('*')" 
                    @change="adjustFilters('completed'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    Completed
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('errored') || filters.includes('*')" 
                    @change="adjustFilters('errored'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    Errored
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('cancelled') || filters.includes('failed to queue') || filters.includes('*')" 
                    @change="adjustFilters('cancelled'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    Cancelled
                  </label>
                </div>
                <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check">
                  <input type="checkbox" :checked="filters.includes('expired') || filters.includes('failed to queue') || filters.includes('*')" 
                    @change="adjustFilters('expired'); adjustFilters('failed to queue'); searchJobs();">
                  <label style="color: #484848; font-size: .9em;">
                    Expired
                  </label>
                </div>
                <div style="width: 100%; display: flex;">
                    <div v-if="action !== 'createJob'" class="jobs-body__tab-item dropdown form-check">
                    <select v-on:change="searchJobs()" v-model="sortProperty" class="form-select form-select-sm" style="margin-right: .75em;" aria-label="Sort property">
                      <option selected value="">Sort</option>
                      <option v-for="sort in sortProperties" :value="sort" :key="sort">{{ sort }}</option>
                    </select>
                  </div>
                  <div v-if="action !== 'createJob'" class="jobs-body__tab-item dropdown form-check">
                    <select v-on:change="searchJobs()" v-model="sortDirection" class="form-select form-select-sm" style="margin-right: .75em;" aria-label="Sort direction">
                      <option selected value="">Direction</option>
                      <option v-for="sort in sortDirections" :value="sort" :key="sort">{{ sort }}</option>
                    </select>
                  </div>
                  <div v-if="action !== 'createJob'" class="jobs-body__tab-item form-check" style="flex: 1; margin-right: 0;">
                    <input v-on:change="searchJobs()" v-model="searchTerm" class="form-input form-input-sm" 
                      style="word-wrap: normal; border: 1px solid #ebebeb; height: 40px; border-radius: 5px; color: #212529; 
                             padding: 15px; font-size: 15px; -webkit-appearance: none; -moz-appearance: none; appearance: none; 
                             background: transparent; cursor: pointer; width: 100%;" aria-label="Partial job search" placeholder="Search by Template, Job ID or Display Name and press Enter" />
                  </div>
                </div>
              </div>
              <b-pagination
                v-if="jobs.total && jobs.total > 0"
                :total-rows="jobs.total"
                :per-page="jobs.limit"
                :value="Math.floor(jobs.skip / jobs.limit) + 1"
                @change="changeJobsPage"
                size="sm"
              ></b-pagination>
              <div v-if="!transformedJobs.length">
                <small>No jobs available. Adjust your query.</small>
              </div>
              <div v-if="loading" style="flex: 1; margin-top: 5em; margin-bottom: 5em; display: flex; justify-content: center; align-items: center">
                <img src="../../assets/images/loader-a2.gif" alt="Loading items" width="50px" />
              </div>
              <div v-if="!loading && Array.isArray(transformedJobs) && transformedJobs.length" class="jobs-body-inspector__job-item jobs-body__bounce" @click="sensorJobContainerId ? doAction('viewJobCollection', sensorJobContainerId, tenant) : doAction('viewJob', sensorJobRequestId, tenant)" style="cursor: pointer;" v-for="{
                displayName, createdAt, cancelledAt, sensorJobRequestId, sensorJobContainerId, user, state, template, tenant, templateId, modifiedAt, scheduledTimeStamp, isSilent, expiration, startedAt, completedAt, devices, tasks, children,
              } in transformedJobs" :value="sensorJobRequestId" :key="sensorJobRequestId">
                <div style="display: flex; gap: .75em; justify-content: flex-start; align-items: center;">
                  <b-button :id="`job-details-${sensorJobRequestId}`" style="width: 24px; height: 24px; border-width: 0px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--radio-button">
                    <font-awesome-icon :style="{ width: '15px', height: '15px' }" icon="info" /> 
                  </b-button>
                  <div style="font-weight: 400;display: inline-flex; justify-content: flex-start; flex: 1 1 0%; flex-direction: column;">
                    <b>
                      {{  displayName ? displayName : `${tenant} - ${template}`}}                     
                    </b> 
                    <div style="display: flex; flex-direction: row; gap: .75em; margin-top: .25em;">
                      <div v-if="template" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Template</strong></small>
                        <small>{{ template }}</small>
                      </div>
                      <div v-if="scheduledTimeStamp && !isSilent" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Scheduled Execution Time</strong></small>
                        <small>{{ scheduledTimeStamp === 'ASAP' ? scheduledTimeStamp : moment(scheduledTimeStamp).format("dddd, MMMM Do YYYY, h:mm:ss a") }}</small>
                      </div>
                      <!-- We don't need this yet. It's not working as expected during a run through justs now. This is for `model deployment` which is WIP -->
                      <!-- <div v-if="isSilent" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Non-locking Job</strong></small>
                        <small>This job will not interfere with device operations while running.</small>
                      </div> -->
                      <div v-if="startedAt" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Started At</strong></small>
                        <small>{{ moment(startedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}</small>
                      </div>
                      <div v-if="cancelledAt" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Cancelled At</strong></small>
                        <small>{{ moment(cancelledAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}</small>
                      </div>
                      <div v-if="completedAt" style="display: flex; flex-direction: column; gap: .25em;">
                        <small><strong>Completed At</strong></small>
                        <small>{{ moment(completedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}</small>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: flex-end;">
                    <span v-if="!Array.isArray(children)">
                      <font-awesome-icon :style="{ color: '#1dd8f6', 'margin-right': '.75em' }" v-if="!['completed', 'errored',  'cancelled', 'expired', 'scheduled'].includes(state)" icon="cloud" />
                      <font-awesome-icon :style="{ color: '#eed202', 'margin-right': '.75em' }" v-if="['errored', 'cancelled', 'expired'].includes(state)" icon="exclamation-triangle" />
                      <font-awesome-icon :style="{ color: '#66be6d', 'margin-right': '.75em' }" v-if="['completed'].includes(state)" icon="check" />
                      <font-awesome-icon :style="{ color: '#1dd8f6', 'margin-right': '.75em' }" v-if="['scheduled'].includes(state)" icon="calendar" />
                      {{ state.toUpperCase() === 'ERRORED' ? 'COMPLETED (at least one failure)': state.toUpperCase()}}
                    </span>
                    <span v-if="Array.isArray(children)">
                      <font-awesome-icon v-if="children.every((item) => ['completed'].includes(item.state))" :style="{ color: '#66be6d', 'margin-right': '.75em' }"  icon="check" />
                      <font-awesome-icon v-else-if="children.every((item) => ['scheduled'].includes(item.state) || ['completed', 'progressing'].includes(item.state) && item.isSilent)" :style="{ color: '#1dd8f6', 'margin-right': '.75em' }"  icon="calendar" />
                      <font-awesome-icon v-else-if="children.some((item) => ['progressing'].includes(item.state))" :style="{ color: '#1dd8f6', 'margin-right': '.75em' }"  icon="cloud" />
                      <font-awesome-icon v-else-if="
                        children.every(item => ['completed', 'expired', 'cancelled'].includes(item.state)) && 
                        children.some(item => ['cancelled', 'expired'].includes(item.state)) && 
                        children.some(item => item.state === 'completed' && !item.isSilent)
                      " :style="{ color: '#eed202', 'margin-right': '.75em', transform: 'scaleX(-1)' }"  icon="slash"  />
                      <font-awesome-icon v-else-if="children.every((item) => ['cancelled', 'expired'].includes(item.state))" :style="{ color: '#eed202', 'margin-right': '.75em' }"  icon="exclamation-triangle" />
                      
                      <span style="font-size: 1.2em;">
                        <span v-if="children.every((item) => ['completed'].includes(item.state))"> COMPLETED </span>
                        <span v-else-if="children.every((item) => ['scheduled'].includes(item.state) || ['completed', 'progressing'].includes(item.state) && item.isSilent)"> SCHEDULED </span>
                        <span v-else-if="children.some((item) => ['progressing'].includes(item.state) && !item.isSilent)"> PROGRESSING </span>
                        <span v-else-if="!children.every((item) => ['completed'].includes(item.state)) && (children.every((item) => ['completed', 'cancelled', 'expired'].includes(item.state) && children.some((item) => ['completed'].includes(item.state) && !item.isSilent)))"> 
                          FINISHED (at least one cancelled) 
                        </span>
                        <span v-else-if="children.every((item) => ['cancelled', 'expired'].includes(item.state) || item.state === 'completed' && item.isSilent )"> 
                          CANCELLED
                        </span>
                      </span>
                    </span>
                    <i v-if="modifiedAt && state === 'progressing'" style="font-size: 10px;">
                      Last update at {{ moment(modifiedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && Array.isArray(children)" style="font-size: 10px;">
                        {{
                          children.reduce((count, child) => {
                            (child.devices || []).forEach((device) => {
                              if (device && device.isCompleted) count += 1;
                            });
                            return count;
                          }, 0)
                        }} / {{ 
                          children.reduce((count, child) => {
                            (child.devices || []).forEach(() => {
                              count += 1;
                            });
                            return count;
                          }, 0)
                        }} devices complete.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && devices.length && !Array.isArray(children)" style="font-size: 10px;">
                      {{ devices.filter((device) => (Array.isArray(device.tasksComplete) ? device.tasksComplete.length : 0) === tasks.length).length }} devices complete.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && Array.isArray(children) && children.filter((child) => !child.isSilent).length" style="font-size: 10px;">
                      {{
                        children.reduce((total, child) => {
                          const childrenTasks = child.isSilent ? 0 : child.devices
                            ? child.devices.reduce((childTotal, child) => {
                                return childTotal + (Array.isArray(child.tasksComplete) 
                                  ? child.tasksComplete.length 
                                  : child.tasksComplete || 0);
                              }, 0)
                            : 0;
                          return total + childrenTasks;
                        }, 0) 
                      }} / {{ 
                        children.reduce((sum, child) => {
                          const taskCountForDevice = child.isSilent ? 0 : (child.devices ? child.devices.length : 0);
                          return sum + taskCountForDevice * child.tasks.length;
                        }, 0) 
                      }} tasks complete across {{ children.filter((child) => !child.isSilent).length }} jobs.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && Array.isArray(children) && children.filter((child) => child.isSilent).length" style="font-size: 10px;">
                      {{
                        children.reduce((total, child) => {
                          const childrenTasks = child.isSilent ? child.devices
                            ? child.devices.reduce((childTotal, child) => {
                                return childTotal + (Array.isArray(child.tasksComplete) 
                                  ? child.tasksComplete.length 
                                  : child.tasksComplete || 0);
                              }, 0)
                            : 0 : 0;
                          return total + childrenTasks;
                        }, 0) 
                      }} / {{ 
                        children.reduce((sum, child) => {
                          const taskCountForDevice = child.isSilent ? (child.devices ? child.devices.length : 0) : 0;
                          return sum + taskCountForDevice * child.tasks.length;
                        }, 0) 
                      }} tasks complete across {{ children.filter((child) => child.isSilent).length }} non-locking jobs.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && !Array.isArray(children)" style="font-size: 10px;">
                      {{ 
                        devices.reduce((sum, item) => sum + (item.tasksComplete ? Array.isArray(item.tasksComplete) ? item.tasksComplete.length : item.tasksComplete : 0), 0) 
                      }} / {{ 
                        devices.length * tasks.length 
                      }} tasks complete.
                    </i>
                    <i v-if="Array.isArray(devices) && Array.isArray(tasks) && devices.filter((device) => device.errorDetected).length !== 0" style="font-size: 10px;">
                      {{ new Set(devices.filter((device) => device.errorDetected).map(item => item.deviceId)).size }} devices reporting errors.
                    </i>
                  </div>
                  <div style="display: flex; justify-content: flex-end;">
                    <button  v-if="['scheduled'].includes(state)" @click.stop="doAction('editDeployment', sensorJobRequestId + '|' + templateId + '|' + tenant);" 
                      style="font-size: 15px; padding-bottom: 6px; padding-left: 9px; margin-right: 10px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--edit-button">
                      <font-awesome-icon :style="{ width: '14px' }" icon="edit" /> 
                    </button>
                    <button v-if="jobsManager && ['cancelled', 'completed', 'expired'].includes(state)" @click.stop="doAction('rerunDeployment', sensorJobRequestId + '|' + templateId + '|' + tenant);" class="btn-sm btn-success btn-margin jobs-body__tab-item--schedule-button">
                      <font-awesome-icon :style="{ width: '14px' }" icon="recycle" /> 
                    </button>
                    <button  v-if="!['completed', 'cancelled', 'expired', 'errored'].includes(state)" @click.stop="doAction('cancelJob', sensorJobRequestId); state = 'cancelled'" style="font-size: 15px; padding-bottom: 6px; padding-left: 9px; margin-right: 10px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--cancel-button">
                      ⨉
                    </button>
                  </div>

                  <b-popover :target="`job-details-${sensorJobRequestId}`" id="jobDetails" 
                    triggers="hover" placement="top"
                    v-bind:title="'Job Details'">
                    <p v-if="Array.isArray(children) && children.length">
                      <strong>Job IDs: </strong> 
                      <span style="font-weight: 300;" v-html="children.map((child) => '<br>' + child.sensorJobRequestId).join(' <br>')">
                      </span>
                    </p>
                    <p v-if="!Array.isArray(children) || !children.length">
                      <strong>Job ID: </strong> 
                      <span style="font-weight: 300;">
                        {{ sensorJobRequestId }}
                      </span>
                    </p>
                    <p>
                      <strong>Creation: </strong> 
                      <span style="font-weight: 300;">
                        {{moment(createdAt).format("dddd, MMMM Do YYYY, h:mm:ss a")}} by {{user.id}}
                      </span>
                    </p>
                    <p v-if="expiration">
                      <strong>Expires: </strong>
                      {{ expiration ? new Date(expiration).toLocaleString() : '' }}
                    </p>
                  </b-popover>
                </div>

              </div>

            </div>
          </div>
        </div>
        <!-- // Viewing Job -->
        <div v-if="action === 'viewJob'" class="jobs-body-inspector-row">
          <job 
            :details="{...transformedJobs.find(job => viewJob === job.sensorJobRequestId), tenant: tenant}" :key="viewJob" :templates="[ ...this.templates.data, ...this.releases.data ]" 
            @recycle="(payload) => {
              this.preloadDevices = payload.devices;
              this.doAction('scheduleJob', payload.template);
            }"
            />
        </div>
        <!-- // Viewing Job Collection -->
        <div v-if="action === 'viewJobCollection'" class="jobs-body-inspector-row">
          <div style="display: flex; flex-direction: column; flex: 1; gap: 15px;" v-if="transformedJobs.find(job => viewJob === job.sensorJobContainerId)">
            <job
              v-for="job in (transformedJobs.find(job => viewJob === job.sensorJobContainerId)).children"
              :details="{...job, tenant: tenant}" :key="job.sensorJobRequestId" :templates="[ ...templates.data, ...releases.data ]" 
              @recycle="(payload) => {
                this.preloadDevices = payload.devices;
                this.doAction('scheduleJob', payload.template);
              }"
            />
          </div>

        </div>
        <!-- // Creating Job -->
        <div v-if="action === 'createJob' && jobsManager" class="jobs-body-inspector-row">
          <create-job :preloadJob="preloadJob" :details="{tenant: this.tenants.find((item) => item.value === tenant)}" @return="() => { doAction('refresh').then(() => {
            this.action = 'releasesAndTemplates';
          }); this.preloadJob = null; }" />
        </div>
        <!-- // Creating Job -->
        <div v-if="action === 'scheduleJob'" class="jobs-body-inspector-row">
          <deploy-job :preloadDeployment="preloadDeployment" :preloadDevices="preloadDevices" :jobsManager="jobsManager" :details="{tenant: this.tenants.find((item) => item.value === tenant), release: [ ...this.templates.data, ...this.releases.data ].find((item) => item._id === deployJob)}" @return="() => { doAction('refresh').then(); this.preloadDevices = null; }" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CreateJob from "./CreateJob.vue";
import DeployJob from "./DeployJob.vue";
import Job from "./Job.vue";

const moment = require("moment");

Vue.component('create-job', CreateJob);
Vue.component('deploy-job', DeployJob);
Vue.component('job', Job);

Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "Jobs",
  components: { },
  data() {
    return {
      console: console,
      jobsManager: this.$auth && this.$auth.user && this.$auth.user.hasOwnProperty('https://care.ai/permissions') && this.$auth.user['https://care.ai/permissions'].find((role) => role === "jobs:mgr") ? true : false,
      moment: moment,
      sortProperties: ['createdAt', 'scheduledTimeStamp', 'completedAt'],
      sortProperty: 'createdAt',
      sortDirections: ['asc', 'desc'],
      sortDirection: 'desc',
      searchTerm: '',
      pending: 0,
      completed: 0,
      tenants: [],
      loading: false,
      tenant: null,
      viewJob: null,
      action: null,
      showJobDetails: null,
      preloadDevices: null,
      validFilterProperties: [
        'scheduled',
        'progressing',
        'completed',
        'errored',
        'cancelled',
        'expired',
        'failed to queue'
      ],
      filters: [
        '*',
        'scheduled',
        'progressing',
        'completed',
        'errored',
        'cancelled',
        'expired',
        'failed to queue'
      ],
      jobs: {data: []},
      templatesHidden: false,
      templates: {data: []},
      releasesHidden: false,
      releases: {data: []},
      searchTemplatesPhrase: '',
      searchReleasesPhrase: '',
      rerender: true,
    };
  },
  computed: {
    // This computed property implicitly transforms the `jobs` prop
    transformedJobs() {
      return this.jobs.data.reduce((acc, item) => {
        if (item['sensorJobContainerId']) {
          const existingItem = acc.find(i => i['sensorJobContainerId'] === item['sensorJobContainerId']);
          if (existingItem) {
            if (['progressing'].includes(item.state)) existingItem.state = item.state;
            existingItem.children = existingItem.children || [];
            existingItem.children.push(item);
          } else {
            acc.push({ ...item, children: [{...item}] });
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, []);
    }
  },
  mounted() {
    this.getTenants().then();
    this.getItems().then();
    
    // Start Poll
    this.pollInterval = setInterval(() => {
      if (this.action !== 'createJob') {
        this.getItems();
      }
    }, 60000) // Fetches data by the 60 second interval
  
  },
  unmounted() {
    try {
      clearInterval(this.pollInterval);
    } catch { null }
  },
  methods: {
    async changeTenant() {
      this.jobs.data = [];
      this.jobs.skip = 0;
      this.getItems(true);
    },

    async forceRerender() {
      this.rerender = false;
      await this.$nextTick();
      this.rerender = true;
    },

    async getItems() {
      await this.searchJobs();
      await this.getReleases();
      await this.getTemplates();

      setTimeout(() => this.loading = false, 1000);
    },

    async searchJobs(newPage) {
      if (this.filters.length) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const page = newPage ? newPage : this.jobs && this.jobs.skip ? ((this.jobs.skip / this.jobs.limit) + 1) : 1;
        const queryObject = {
          sort: `${this.sortProperty} ${this.sortDirection}`, 
          skip: this.jobs && this.jobs.limit ? this.jobs.limit * (page - 1) : 0,
        };
        if (this.tenant && ['viewJobs', 'viewJob'].includes(this.action)) queryObject.tenant = this.tenant;
        if (this.searchTerm && this.searchTerm.length) queryObject.search = this.searchTerm;
        if (this.filters.length) queryObject.state = this.filters;
        const queryString = new URLSearchParams(queryObject).toString();
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs?${queryString}`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([502, 503].includes(response.status)) {
            this.searchJobs();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            this.completed = 0;
            this.pending = 0;
            const validIDs = [];

            // GET
            const jobs = await response.json();
            if (jobs && Array.isArray(jobs.data) && jobs.data.length) {
              jobs.data.forEach((job) => {
                if (job.state === 'completed' || job.state === 'errored') {
                  this.completed += 1;
                } else {
                  this.pending += 1;
                }
                validIDs.push(job._id);
                const exists = this.jobs.data.find((existing) => job._id === existing._id);
                if (exists) {
                  Object.keys(job).forEach((key) => {
                    exists[key] = job[key];
                  })
                } else this.jobs.data.push(job);

                for (let i = 0; i < this.jobs.data.length; i++) {
                    if (!validIDs.includes(this.jobs.data[i]._id)) {
                      this.jobs.data.splice(i, 1);
                        i--; 
                    }
                }
              });
            } else if (jobs && Array.isArray(jobs.data) && !jobs.data.length) {
              this.jobs.data = [];
            }
            this.jobs.total = jobs.pagination ? jobs.pagination.total : 0;
            this.jobs.limit = jobs.pagination ? jobs.pagination.limit : 0;
            this.jobs.rows = Math.ceil(this.jobs.total / this.jobs.limit);
            this.jobs.skip = jobs.pagination ? jobs.pagination.skip : 0;
            this.jobs.hasNextPage = jobs.pagination ? jobs.pagination.hasNextPage : 0;
            this.jobs.hasPreviousPage = jobs.pagination ? jobs.pagination.hasPreviousPage : 0;
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to search jobs due to an error.', type: 'error'});
        }
      } else if (!this.filters.length) {
        this.jobs.data = [];
      }
    },

    async adjustFilters(filter) {
      if (this.filters.includes(filter)) {
        this.filters = this.filters.filter((item) => ![filter, "*"].includes(item));
        if (filter === "*") this.filters = [];
      } else {
        this.filters.push(filter);
        if (this.validFilterProperties.every(item => this.filters.includes(item)) || filter === "*") {
          this.filters.push('*');
          this.validFilterProperties.forEach((item) => this.filters.push(item));
        } else {
          this.filters = this.filters.filter((item) => item !== '*');
        }
      }

      this.filters = Array.from(new Set(this.filters));
    },

    async getReleases() {
      if (this.filters.length) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const queryObject = {sort: `createdOn desc`};
        if (this.action === 'archived') {
          queryObject.archived = true;
        }
        if (this.searchReleasesPhrase) {
          if (this.releasesHidden) {
            this.$refs.showReleases.click()
          }
          queryObject.search = this.searchReleasesPhrase;
        }
        const queryString = new URLSearchParams(queryObject).toString();
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs/templates?${queryString}`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([502, 503].includes(response.status)) {
            this.getReleases();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            const validIDs = [];

            const res = await response.json();
            const data = res && Array.isArray(res.data) ? res.data : [];

            // GET
            data.forEach((template) => {
              validIDs.push(template._id);
              const exists = this.releases.data.find((existing) => template._id === existing._id);
              if (exists) {
                Object.keys(template).forEach((key) => {
                  exists[key] = template[key];
                })
              } else this.releases.data.push(template);
            });
            
            for (let i = 0; i < this.releases.data.length; i++) {
                  if (!validIDs.includes(this.releases.data[i]._id)) {
                    this.releases.data.splice(i, 1);
                      i--; 
                  }
            }

            this.releases.data.sort((a, b) => {
              // Custom sort logic
              const aPriority = (a.isInService ? 2 : 0) + (a.isApproved ? 1 : 0);
              const bPriority = (b.isInService ? 2 : 0) + (b.isApproved ? 1 : 0);

              // First sort by custom priority
              if (aPriority > bPriority) return -1;
              if (aPriority < bPriority) return 1;

              return new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime();
            })
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get items due to an error.', type: 'error'});
        }
      }
    },

    async getTemplates() {
      if (this.filters.length) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const queryObject = { sort: `createdOn desc`, isTemplate: true };
        if (this.searchTemplatesPhrase) {
          if (this.templatesHidden) {
            this.$refs.showTemplates.click()
          }
          queryObject.search = this.searchTemplatesPhrase;
        }
        if (this.action === 'archived') {
          queryObject.archived = true;
        }
        const queryString = new URLSearchParams(queryObject).toString();
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs/templates?${queryString}`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([502, 503].includes(response.status)) {
            this.getTemplates();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            const validIDs = [];

            // GET
            const res = (await response.json());
            res && Array.isArray(res.data) ? res.data.forEach((template) => {
              validIDs.push(template._id);
              const exists = this.templates.data.find((existing) => template._id === existing._id);
              if (exists) {
                Object.keys(template).forEach((key) => {
                  exists[key] = template[key];
                })
              } else this.templates.data.push(template);
            }) : null;
            
            for (let i = 0; i < this.templates.data.length; i++) {
              if (!validIDs.includes(this.templates.data[i]._id)) {
                this.templates.data.splice(i, 1);
                  i--; 
              }
            }

            this.templates.data.sort((a, b) => {
              // Custom sort logic
              const aPriority = (a.isInService ? 2 : 0) + (a.isApproved ? 1 : 0);
              const bPriority = (b.isInService ? 2 : 0) + (b.isApproved ? 1 : 0);

              // First sort by custom priority
              if (aPriority > bPriority) return -1;
              if (aPriority < bPriority) return 1;

              return new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime();
            })
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get items due to an error.', type: 'error'});
        }
      }
    },

    async updateTemplate(id, body) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const update = {};
      if (typeof body.isApproved === 'boolean') {
        update.isApproved = body.isApproved;
      }
      if (typeof body.isInService === 'boolean') {
        update.isInService = body.isInService;
      }
      var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/sensors/jobs/templates/${id}`, 
        {
          method: 'PATCH',
          body: JSON.stringify(update),
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if ([502, 503].includes(response.status)) {
          this.updateTemplate(id, body);
        }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          alert('Updating item.');
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to update template due to an error.', type: 'error'});
      }
  
    },

    async cancelJobById(id) {
      if (this.tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/tenants/${this.tenant}/sensors/jobs/${id}`, 
          {
            method: 'DELETE',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([502, 503].includes(response.status)) {
            this.cancelJobById(id);
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to cancel jobs due to an error.', type: 'error'});
        }
      }
    },

    changeJobsPage(event) {
      if (this.searchTerm) {
        this.searchJobs(event);
      } else this.searchJobs(event);
    },

    async getTenants() {
      this.tenants = [];
      
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        // eslint-disable-next-line no-undef
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        const tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.getTenants();
        } else {
          const response = await tenants_list.json();
          const tenants = response.sort((a, b) => {
            var nameA = a.text ? a.text.toUpperCase() : ""; // ignore upper and lowercase
            var nameB = b.text ? b.text.toUpperCase() : ""; // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          tenants.forEach((e) =>
            this.tenants.push(JSON.parse(JSON.stringify({ value: e.value, text: e.text || e.value })))
          );
        }
      } catch (error) {}
    },

    async doImport(payload) {
      if (!this.$auth.isAuthenticated) {
          return;
        }

        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs/import-template`, 
          {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            body: payload,
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to POST Job
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([500, 502, 503].includes(response.status)) {
              return this.doImport(payload);
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // GET
            await response.json();
            alert('Release imported.');
            this.getItems({});
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to import job due to an error.', type: 'error'});
        }
    },

    async doAction(type, id = null, tenant) {
      if (tenant) this.tenant = tenant;
      try {
        clearInterval(window.jobInterval);
      } catch { -1; }
      if (type === 'viewJob' && id && this.tenant) {
        this.action = type;
        this.viewJob = id;
      } else if (type === 'archived') {
        this.action = type;
        this.preloadJob = null;
        await this.getItems();
      } else if (type === 'viewJobCollection' && id && this.tenant) {
        this.action = type;
        this.viewJob = id;
      } else if (type === 'createJob') {
        this.preloadJob = null;
        this.action = type;
      } else if (type === 'rerunDeployment') {
        const result = confirm("Are you sure you want to rerun this job?");
        if (result && Array.isArray(this.jobs.data)) {
          const [sensorJobRequestId, templateId, tenant] = id.split('|');
          this.tenant = tenant;
          if (!this.tenant) {
            alert('Select a tenant to schedule a job.');
            return;
          }
          if (!templateId || templateId === 'undefined') {
            alert('No template found. Cannot edit or reschedule.');
            return;
          }
          this.action = type;
          this.deployJob = templateId;
          this.preloadDeployment = JSON.parse(JSON.stringify(this.jobs.data.find((job) => job.sensorJobRequestId === sensorJobRequestId)));
          this.action = 'scheduleJob';
        }
      } else if (type === 'editDeployment') {
        const result = confirm("Are you sure you want to edit this job?");
        if (result && Array.isArray(this.jobs.data)) {
          const [sensorJobRequestId, templateId, tenant] = id.split('|');
          this.tenant = tenant;
          if (!this.tenant) {
            alert('Select a tenant to schedule a job.');
            return;
          }
          if (!templateId || templateId === 'undefined') {
            alert('No template found. Cannot edit or reschedule.');
            return;
          }
          this.action = type;
          this.deployJob = templateId;
          this.preloadDeployment = JSON.parse(JSON.stringify(this.jobs.data.find((job) => job.sensorJobRequestId === sensorJobRequestId)));
          this.preloadDeployment.cancelOnSubmit = true;
          this.action = 'scheduleJob';
        }
      } else if (type === 'cancelJob') {
        const result = confirm("Are you sure you want to cancel this job?");
        if (result) {
          const job = this.transformedJobs.find((job) => job.sensorJobRequestId === id);
          if (job) {
            this.tenant = job.tenant;
            if (Array.isArray(job.children)) {
              job.children.forEach(async (child) => {
                if (['scheduled', 'progressing'].includes(child.state)) {
                  await this.cancelJobById(child.sensorJobRequestId);
                }
              })
            } else {
              await this.cancelJobById(id);
            }
            alert('Job is being cancelled.');
          }
        }
      } else if (type === 'removeServiceTemplate') {
        const result = confirm("Are you sure you want to remove this item from service? Once done, you'll need to recreate this item.");
        if (result) {
          await this.updateTemplate(id, {
            isInService: false,
          });
          await this.getItems({});
        }
      } else if (type === 'approveTemplate') {
        const result = confirm(`Are you sure you want to approve this item?`);
        if (result) {
          await this.updateTemplate(id, {
            isApproved: true,
          });
          await this.getItems({});
        }
      } else if (type === 'unapproveTemplate') {
        const result = confirm("Are you sure you want to unapprove this release?");
        if (result) {
          await this.updateTemplate(id, {
            isApproved: false,
          });
          await this.getItems({});
        }
      } else if (type === 'scheduleJob') {
        if (!this.tenant) {
          alert('Select a tenant to schedule a job.');
        } else {
          this.preloadDeployment = null;
          this.action = type;
          this.deployJob = id;
        }
      } else if (type === 'refresh') {
        this.action = 'viewJobs';
        setTimeout(async () => {
          await this.getItems({});
        }, 2000);
      } else if (type === 'editTemplate') {
        const job = [ ...this.templates.data, ...this.releases.data ].find((item) => item._id === id);
        if (job) this.preloadJob = JSON.parse(JSON.stringify(job));
        this.action = 'createJob';
      } else if (type === 'exportItem') {
        const release = [ ...this.templates.data, ...this.releases.data ].find((item) => item._id === id);
        const jsonString = JSON.stringify(release, null, 2);
        const blob = new Blob([jsonString], { type: 'application/json' });
        const link = document.createElement('a');
        link.download = `${release.label.replace(' ', '-')}-${release.createdOn}-Exported-By-${this.$auth.user['https://care.ai/userId']}-At-${(new Date()).toISOString()}.json`;
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (type === 'importItem') {
        const input = document.createElement('input');
        input.type = 'file';
        input.style.display = 'none';
        input.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const contents = e.target.result;
                    this.doImport(contents);
                };
                reader.readAsText(file); 
            }
        });
        document.body.appendChild(input);
        input.click();
        input.addEventListener('change', () => {
            document.body.removeChild(input);
        });
      } else if (type === 'viewJobs') {
        this.preloadJob = null;
        this.action = 'viewJobs';
        setTimeout(async () => {
          await this.getItems();
        }, 2000);
      } else if (type === 'releasesAndTemplates') {
        this.action = 'releasesAndTemplates';
        setTimeout(async () => {
          await this.getItems();
        }, 2000);
      } else {
        if (this.action === 'viewJob') {
          this.action = 'viewJobs';
        } else {
          this.action = null;
          setTimeout(async () => {
            await this.getItems();
          }, 2000);
        }
      }
    }
  },
};
</script>

<!-- Header Styles -->
<style lang="scss" scoped>
  .page-header {
    &__flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__statistics {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__statistics-item {
      font-size: .7em;
      display: flex;
      flex-direction: column;
    }
  }
</style>  

<!-- Body Styles -->
<style lang="scss" scoped>
  button {
    transition: all ease-in-out 300ms;
  }

  .jobs-body {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 0 1em;
    font-size: 1.2em;

    // Only affects small tags within this page
    small {
      font-size: 12px;
    }

    .collapsed {
      .job-details-icon-expand {
        display: inline-block;
      }
      .job-details-icon-collapse {
        display: none;
      }
    }

    .not-collapsed {
      .job-details-icon-expand {
        display: none;
      }
      .job-details-icon-collapse {
        display: inline-block;
      }
    }

    .card-body {
      display: flex;
      flex-direction: column;
      gap: 15px;
      padding: 15px;
      .jobs-body-inspector__job-item p{
        margin-left: 0px;
        strong{
          text-align: left;
          min-width: 100px;
        }
      }
    }

    p {
      margin: 0;
    }

    .nav {
      display: flex; 
      gap: .33em;

      .nav-item {
        margin: 0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding-bottom: .3em;
        background: transparent;
        border-top: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-left: 1px solid #f3f3f3;
        transition: all ease-in-out 300ms;

        a.nav-link {
          padding: 0.25rem 1rem;
          color: #484848;
          font-size: 15px;
          font-weight: 400;
        }

        &:hover {
          background: #f3f3f3;
        }
      }

      .active {
        background: #00b5da;

        a.nav-link {
          color: white;
        }

        &:hover {
          background: #1dd8f6;
        }
      }
    }

    &__inner {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      padding: .75em;
      border-bottom-left-radius: .25em;
      border-bottom-right-radius: .25em;
      border: 1px solid #f1f1f1;
    }

    &__tab-container {
      display: flex;
      flex-wrap: wrap;
      padding: 0.75em 0;
      position: sticky;
      top: 0;
      background: white;
      width: 100%;
      z-index: 1;
    }

    &__tab-item {
      transition: color 150ms;
      color: #484848;
      padding:0 0.75em 0.75em 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      &.dropdown{
        padding: 0;
      }

      &--schedule-button {
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: transparent;
        color: #28a745; 
        display: flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid #66be6d;
        transition: all ease-in-out 300ms;

        &:hover {
          color: white;
          background: #28a745; 
        }
      }

      &--cancel-button {
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: transparent;
        color: #ebd15c; 
        display: flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid #ebd15c;
        transition: all ease-in-out 300ms;

        &:hover {
          color: white;
          background: #ebd15c; 
        }
      }

      &--edit-button {
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: transparent;
        color: #00b5da; 
        display: flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid #00b5da;
        transition: all ease-in-out 300ms;

        &:hover {
          color: white;
          background: #00b5da; 
        }
      }

      &--radio-button {
        justify-content: center;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: transparent;
        color: #2e2e2e; 
        display: inline-flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid transparent;
        transition: all ease-in-out 300ms;

        &:hover {
          background: #d7d7d7; 
        }
      }

      &--back {
        color: rgb(35, 35, 35);
      }

      &--button {
        color: rgb(248, 248, 248);
        border: none;
        outline:none;

        &:hover {
          color: white;
        }
      }

      &--refresh-button {
        width: 20px; 
        height: 20px; 
        filter: brightness(0) saturate(100%) invert(36%) sepia(18%) saturate(0%) hue-rotate(179deg) brightness(82%) contrast(93%);
        transition: all ease-in-out 300ms;

        &:hover {
          filter: brightness(0) saturate(100%) invert(49%) sepia(7%) saturate(6%) hue-rotate(337deg) brightness(66%) contrast(88%);
        }
      }

      label {
        margin-bottom: 0;
        margin-left: .25em;
      }

      &--selected {
        color: #1dd8f6;
      }

      &:hover {
        color: #1dd8f6;
      }
    }
  }

  .jobs-body__bounce {
    opacity: 0;
    transform: scale(1);
    animation: fadeIn 800ms forwards;
    margin-bottom: 15px !important;
    &:last-child{
      margin-bottom: 0px !important;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .jobs-body__inspector-crumbs {
    display: flex;
    flex: 100%;
    margin: .25em .25em 0 .25em;
    font-size: .8em;
    align-items: center;

    * {
      cursor: pointer;
    }
  }


  .jobs-body__inspector-crumb-item {
    color: #484848;
    transition: color 150ms;

    &:not(:first-of-type) {
      margin-left: .25em;
    }

    &:hover {
      color:#1dd8f6;
    }
  }

  .jobs-body-inspector-row {
    display: flex;
    flex: 100%;
    gap: .75em;
  }

  .jobs-body-inspector {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    flex: 50%;
    padding: .75em;
    border-radius: .25em;
    border: 1px solid #f1f1f1;

    &__header {
      width: 100%;
    }

    &__details {
      display: flex;
      font-size: .8em;
      color: #484848;
      flex: 1;
      flex-direction: column;
      gap: .75em;
      overflow: auto;
      .jobs-body-inspector__job-item.right{
        margin-right: 0.75em;
      }
    }

    &__job-item {
      display: flex;
      flex-direction: column;
      padding: 15px;
      gap: .75em;
      border-radius: .25em;
      border: 1px solid rgba(0, 0, 0, .05);
      background: rgba(0, 0, 0, .03);
      margin-bottom: 0px;

      p {
        display: flex;
        margin-left: 10px;
        strong {
          display: inline-block;
          min-width: 90px;
          text-align: right;
          padding-right: .75em;
        }
      }

      span {
        font-size: .8em;
        display: inline-flex;
        align-items: center;
      }
    }
  }

  .page-header__statistics-item {
    &:not(:last-of-type) {
      margin-right: 1em;
    }
  }

  * {
    -webkit-animation: fadein 333ms; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 333ms; /* Firefox < 16 */
        -ms-animation: fadein 333ms; /* Internet Explorer */
         -o-animation: fadein 333ms; /* Opera < 12.1 */
            animation: fadein 333ms;
  }
  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  .dropdown:before{
    display: none;
    
  }
  select {
    word-wrap: normal;
    border: 1px solid #ebebeb;
    height: 40px;
    border-radius: 5px;
    padding: 0 30px 0 10px;
    font-size: 15px;
    color: #212529;
    -webkit-appearance:none;
	-moz-appearance:none;
	-ms-appearance:none;
	appearance:none;
  background: transparent;
  cursor: pointer;
  &:focus-visible{
    outline: none;
  }
}
.dropdown:after{
	content: "";
    border: solid #8e8e8e;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    position: absolute;
    right: 25px;
    top: 15px;
    z-index: 1px;
}
input[type="radio"], input[type="checkbox"]{
  zoom: 1.2;
}
</style>

<style>
::-webkit-scrollbar {
  width: 6px; 
  height: 6px;
}</style>
